import { Message, ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export class CreateUserRequest extends ReplyVerifyingMessage {
    public tag: MessageTag = MessageTag.REQ_CREATE_USER;
    public static tag: MessageTag = MessageTag.REQ_CREATE_USER;

    constructor (
        public login: string,
        public password: string,
        public name: string,
        public phone: string,
        public countryCodeIndex: number,
        public languageCodeIndex: number,
        public groups: any,
        public zones: any
    ) {
        super();
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/create-user-request.ts